<template>
  <v-dialog
    content-class="radius-20"
    persistent
    v-model="showDialog"
    max-width="1200"
  >
    <v-card class="py-4">
      <v-card-title>
        <h2 class="my-2">
          {{ isEdit ? $t("label.editItem") : $t("label.addItem") }}
        </h2>
      </v-card-title>

      <v-card-text class="py-0">
        <v-form ref="scmItemForm" v-model="validForm">
          <v-container class="py-0">
            <v-row>
              <v-col sm="12" cols="12" class="align-self-center mb-4">
                <section class="file-upload">
                  <p>Item Photo</p>
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="itemInfo.photo ? itemInfo.photo.path : ''"
                    :imgId="itemInfo.photo ? itemInfo.photo.id : ''"
                    @fileSelected="profileChange"
                    fieldName="mainImgFile"
                    :maxSize="maxSize"
                    :reset="resetBoolean"
                  />
                  <!-- <p class="my-2 gray">
                    <small
                      >Upload photo <br />
                      Should be (300 * 320)</small
                    >
                  </p> -->
                  <template v-if="itemInfo.photo != null">
                    <a
                      :href="itemInfo.photo"
                      target="_blank"
                      v-if="isEdit === true"
                      class="mt-8"
                    >
                      show image
                    </a>
                  </template>
                </section>
              </v-col>
              <v-col cols="12">
                <p>{{ $t("label.itemInfo") }}</p>
              </v-col>
              <v-col class="py-0" cols="12" sm="3">
                <v-text-field
                  v-model="itemInfo.code"
                  :rules="[rules.required, rules.maxLen(190), rules.minLen(2)]"
                  :label="$t('label.itemCode')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="9">
                <v-text-field
                  v-model="itemInfo.name"
                  :rules="[rules.required, rules.maxLen(190), rules.minLen(2)]"
                  :label="$t('label.name')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-select
                  v-model="itemInfo.category"
                  :rules="[rules.required]"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  outlined
                  :label="$t('label.category')"
                ></v-select>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-select
                  v-if="subCategories.length"
                  v-model="itemInfo.sub_category"
                  :rules="[rules.required]"
                  :items="subCategories"
                  item-text="name"
                  item-value="id"
                  outlined
                  :label="$t('label.subCategory')"
                ></v-select>
              </v-col>

              <v-col class="py-0 transparent-field" cols="12" sm="4">
                <v-switch
                  v-model="itemInfo.active"
                  :true-value="1"
                  :false-value="0"
                  inset
                  :label="$t('label.active')"
                  color="success"
                ></v-switch>
              </v-col>

              <v-col cols="12">
                <h4>{{ $t("label.itemQuantity") }}</h4>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model.number="itemInfo.yearly_needed_qty"
                  :rules="[rules.required, rules.minVal(0)]"
                  :label="$t('label.yearlyNeed')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model.number="itemInfo.percent_of_safty_stock"
                  :rules="[rules.required, rules.minVal(0)]"
                  :label="$t('label.safetyPercent')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model.number="itemInfo.amount_of_purchase"
                  :rules="[rules.required, rules.minVal(0)]"
                  :label="$t('label.amountOfPurchace')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model.number="itemInfo.max_stock"
                  :rules="[
                    rules.required,
                    rules.integer,
                    rules.minVal(Number(itemInfo.min_stock) + 1),
                  ]"
                  :label="$t('label.maxStock')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model.number="itemInfo.min_stock"
                  :rules="[
                    rules.required,
                    rules.integer,
                    rules.minVal(0),
                    rules.maxVal(itemInfo.max_stock - 1),
                  ]"
                  :label="$t('label.minStock')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model.number="itemInfo.waiting_days"
                  :rules="[rules.required, rules.integer, rules.minVal(0)]"
                  :label="$t('label.waitingDays')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-select
                  v-model="itemInfo.unit_of_measure"
                  :items="UOMs"
                  item-text="name"
                  item-value="id"
                  outlined
                  :label="$t('label.primaryUOM')"
                ></v-select>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model.number="itemInfo.reorder_qty"
                  :rules="[
                    rules.required,
                    rules.integer,
                    rules.minVal(0),
                    rules.maxVal(itemInfo.max_stock - 1),
                  ]"
                  :label="$t('label.reorderQty')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model.number="itemInfo.last_unit_price"
                  :rules="[rules.required, rules.minVal(0)]"
                  :label="$t('label.lastUnitPrice')"
                  outlined
                ></v-text-field>
              </v-col>

              <v-col class="py-0" cols="12">
                <v-textarea
                  v-model="itemInfo.notes"
                  :rules="[rules.maxLen(5000)]"
                  rows="4"
                  :label="$t('label.notes')"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <slot></slot>
      </v-card-text>

      <v-card-actions class="px-5 justify-end">
        <v-btn
          class="mx-1 px-7 radius-12"
          color="primary"
          outlined
          large
          @click="cancel"
        >
          {{ $t("button.cancel") }}
        </v-btn>

        <v-btn
          class="px-5 radius-12"
          color="primary"
          large
          :loading="loading"
          :disabled="!validForm || loading"
          @click="saveSCMItem"
        >
          {{ $t("button.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/lang";

export default {
  name: "SCMItemsAddEditDialogComponent",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    itemInfo: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    UOMs: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      validForm: true,
      maxSize: 0.512,
      profileBoolean: false,
      resetBoolean: false,
      rules: {
        required: (val) =>
          !!val || val === 0 || i18n.t("validation.requiredField"),
        integer: (val) =>
          !val ||
          (!isNaN(Number(val)) && Number.isInteger(Number(val))) ||
          i18n.t("validation.integerField"),
        minLen(min) {
          return (v) =>
            ((v && v.trim()) || "").length >= min ||
            i18n.t("validation.minLenField", { min });
        },
        maxLen(max) {
          return (v) =>
            ((v && v.trim()) || "").length <= max ||
            i18n.t("validation.maxLenField", { max });
        },
        maxVal(max) {
          return (v) => v <= max || i18n.t("validation.maxValField", { max });
        },
        minVal(min) {
          return (v) => v >= min || i18n.t("validation.minValField", { min });
        },
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.itemInfo.id;
    },
    showDialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    subCategories() {
      const selectedCategory = this.itemInfo.category
        ? this.categories.find((cat) => cat.id === this.itemInfo.category)
        : {};
      return selectedCategory && selectedCategory.sub_categories
        ? selectedCategory.sub_categories
        : [];
    },
  },
  methods: {
    saveSCMItem() {
      this.$emit("saveSCMItem", this.itemInfo.id);
    },
    cancel() {
      this.showDialog = false;
      this.$emit("resetItemInfo");
    },
    profileChange(photo) {
      this.itemInfo.photo = photo.file;
      this.reset = false;
      this.profileBoolean = false;
    },
  },
  watch: {
    showDialog: {
      handler(newVal, oldVal) {
        if (oldVal) {
          this.$emit("resetItemInfo");
          this.$refs.scmItemForm.reset();
        }
      },
    },
  },
};
</script>
